module.exports = __webpack_public_path__ + "media/images/download/e-book11-0c7afa12b9aaea13c8c8511c18b664e7.png";